type DomRef = { current: HTMLElement | null | undefined } | null;

/**
 * Refs to the Header, Cover and BackCover DOM nodes used for PDF/PPTX export.
 * ExportHtmlData registers these so the saga can include their CSS in the export
 * (section header and cover pages keep the same UI as in-app).
 */
let headerRef: DomRef = null;
let coverRef: DomRef = null;
let backCoverRef: DomRef = null;

export function setExportCoverRefs(
  header: DomRef,
  cover: DomRef,
  backCover: DomRef
) {
  headerRef = header;
  coverRef = cover;
  backCoverRef = backCover;
}

/**
 * Returns the current Header, Cover and BackCover DOM elements for use as CSS scope.
 * Used by the export saga so serializeCss includes styles for the section header
 * and cover pages.
 */
export function getExportCoverElements(): HTMLElement[] {
  const nodes: HTMLElement[] = [];
  if (headerRef?.current) nodes.push(headerRef.current);
  if (coverRef?.current) nodes.push(coverRef.current);
  if (backCoverRef?.current) nodes.push(backCoverRef.current);
  return nodes;
}
